import clsx from 'clsx';
import React from 'react';
import { Avatar } from '../../atoms/Avatar';
import { Label } from '../../typography/label';

type CreatorCardProps = {
  fullName: string;
  src?: string | null;
  className?: string;
};

export function CreatorCard({
  fullName,
  src = null,
  className,
  ...props
}: CreatorCardProps & React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div className={clsx('flex max-w-[100px] flex-col items-center gap-3', className)} {...props}>
      <Avatar size="l" src={src} fullName={fullName} />
      <Label className="line-clamp-2 w-full text-center">{fullName}</Label>
    </div>
  );
}
